<script>
import Modal from "@/components/_Shared/Modal";
import Stars from "@/components/_Shared/Professionals/Stars";

export default {
  props: {
    feedback: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    Stars
  },
  data() {
    return {
      preview: true
    };
  }
};
</script>

<template>
  <modal size="md" @close="$emit('close')">
    <template slot="header">
      <div class="header">
        Avaliação
        <stars :rating="feedback.rating" slot="header" />
      </div>
    </template>
    <template slot="body">
      <small>"{{feedback.description}}"</small>
    </template>
    <template slot="footer">
      <div class="btn bg-purple-outline" @click="$emit('close')">fechar</div>
    </template>
  </modal>
</template>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Feedbacks/FullFeedback.vue